export enum TypeProduct {
    location,
    price,
    reviews,
    counts
}
